import { render, staticRenderFns } from "./ComplaintEmisorStatusLabel.vue?vue&type=template&id=ca0966a2"
import script from "./ComplaintEmisorStatusLabel.vue?vue&type=script&lang=js"
export * from "./ComplaintEmisorStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports